import React from "react";

const EditorialPageHeader = ({ eyebrow, title, description, headingId, aside, className = "" }) => (
  <section
    className={`operations-hero editorial-page-header ${className}`.trim()}
    aria-labelledby={headingId}
  >
    <div>
      <p className="platform-eyebrow">{eyebrow}</p>
      <h1 id={headingId}>{title}</h1>
      {description && <p>{description}</p>}
    </div>
    {aside && <div className="editorial-page-header__aside">{aside}</div>}
  </section>
);

export default EditorialPageHeader;
